import template from './dropdown-item-template.html';
export var DropdownItemTemplateComponent = {
    template: template,
    transclude: true,
    require: {
        autocompleteCtrl: '^eeAutocomplete'
    },
    controller: /** @class */ (function () {
        function DropdownItemTemplateComponent() {
            this.hoveredItem = null;
        }
        return DropdownItemTemplateComponent;
    }())
};
//# sourceMappingURL=dropdown-item-template.component.js.map